<template>
  <div class="health-status">
    <ul class="status-list">
      <li v-for="result in results" :key="result.name" class="status-item">
        <div>
          <span class="name"> {{ $t(`admin.health.${result.name}`) }} </span> <br />
          {{ result.description }}
        </div>
        <span :class="`status ${result.status}`">
          {{ $t(`admin.health.status.${result.status}`) }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { ResultStatusDto } from '@onrunning/backstage-models';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'health-status',
  data() {
    return {
      results: [] as ResultStatusDto[],
    };
  },
  mounted() {
    this.fetchHealthStatus();
  },
  methods: {
    async fetchHealthStatus() {
      const apiUrl = import.meta.env.VITE_APP_onBackstageAPI + 'api/health';
      const healthResponse = await fetch(apiUrl);

      this.results = (await healthResponse.json()) as ResultStatusDto[];
    },
  },
});
</script>

<style lang="scss">
.status-list {
  list-style-type: none;
  padding-left: 0;
  border: 1px solid #ccc;
  background-color: var(--primary-bg-color);
}
.status-item {
  display: flex;
  border-bottom: 1px solid #ccc;
  gap: 15px;
  padding: 15px;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  color: var(--primary-text-color);

  &:last-of-type {
    border-bottom: initial;
  }
  .ok {
    color: var(--special-green-color-darker);
  }
  .warning {
    color: var(--special-orange-color-darker);
  }
  .error {
    color: var(--special-red-color-darker);
  }
  .status {
    font-weight: bold;
  }
  .name {
    font-weight: bold;
    margin-bottom: 2em;
  }
}
.health-status {
  @include main-max-with;

  padding: 20px 10px 0;
  width: 100%;
  margin: 0 auto;
}
</style>
